const TONES = {
  surface: "border-hc-surface-border bg-hc-surface",
  shell: "border-hc-surface-border bg-hc-page-shell",
  highlighted: "border-hc-primary/30 bg-hc-primary/5",
};

export default function PlanCard({
  tone = "surface",
  title,
  badge = null,
  footer = null,
  className = "",
  children,
}) {
  return (
    <div
      className={`flex flex-col rounded-2xl border p-5 ${TONES[tone] ?? TONES.surface} ${className}`}
    >
      <div className="flex items-center gap-2">
        <p className="text-base font-bold text-hc-text">{title}</p>
        {badge}
      </div>
      {children}
      {footer}
    </div>
  );
}
